import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import * as pages from './pages';
import { canActivateChildGuard, canActivateGuard } from '@auth/auth-guard.service';
import { LoginGuardService } from '@auth/login-guard.service';
import { customizedScreenRoutes } from '@custom/custom.route';
import { routesResults } from '@pages/results/results.routes';
import { routesRequests } from '@pages/requests/requests.routes';
import { routesEditors } from '@pages/page-editors/editors.routes';
import { routesCustRights } from '@pages/page-custom-right/custrights.routes';
import { routesEditorRights } from '@pages/page-editor-right/editorrights.routes';
import { routesDelegate } from '@pages/page-delegate/delegate.routes';
import { routesDelegateRights } from '@pages/page-delegate-right/delegaterights.routes';
import { routesReqBsk } from '@pages/page-reqbsk/reqbsk.routes';
import { routesUserBsk } from '@pages/page-userbsk/userbsk.routes';
import { routesTagBase } from '@pages/page-tag-base/tagbase.routes';
import { routesTagBsk } from '@pages/page-tagbsk/tagbsk.routes';
import { routesScreenBsk } from '@pages/page-screenbsk/screenbsk.routes';
import { routesUser } from '@pages/page-cfg-users/user.routes';
import { routesGroup } from '@pages/page-cfg-groups/group.routes';
import { PageViewDoc } from '@documalis/page-viewdoc/page-viewdoc.component';
import { routesCustMenuBase } from '@pages/page-custmenu-base/custmenubase.routes';
import { AppLayoutComponent } from './layout/app.layout.component';
import { routesBasket } from '@pages/page-cfg-baskets/basket.routes';
import { routesSupervBase } from '@pages/page-superv-base/supervbase.routes';
import { routesResBsk } from '@pages/page-resbsk/resbsk.routes';
import { docksScreenRoutes } from './docks.route';
import {routesAdminDelegate } from "@pages/page-admin-delegate/admindelegate.routes";

export const ROUTES: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: pages.LoginComponent, canActivate: [LoginGuardService] },
    { path: 'request', component: pages.PageContent },
    { path: 'expired', component: pages.ExpiredComponent },
    { path: 'notfound', component: pages.NotFoundComponent },
    { path: 'page-error', component: pages.PageErrorComponent },    
    { path: 'viewdoc', component: PageViewDoc },
    { path: 'page-reset-pwd', component: pages.PageResetPwdComponent, canActivate: [canActivateGuard] },
    {
        path: '',
        component: AppLayoutComponent,
        canActivateChild: [canActivateChildGuard],
        children: [
            { path: '', component: pages.LoginComponent },
            { path: 'dashboard', component: pages.DashboardComponent },
            { path: 'page-basket-list', component: pages.PageBasketListComponent },
            {
                path: 'page-basket-detail',
                component: pages.PageBasketDetailComponent,
                children: [...docksScreenRoutes, ...customizedScreenRoutes, { path: '', component: pages.NotFoundComponent, outlet: 'aux' }],
            },
            {
                path: 'page-basket-detailbis',
                component: pages.PageBasketDetailComponent,
                children: [...docksScreenRoutes, ...customizedScreenRoutes, { path: '', component: pages.NotFoundComponent, outlet: 'aux' }],
            },
            { path: 'page-basket', component: pages.PageBasketComponent },
            { path: 'page-last-connect', component: pages.PageLastConnectComponent },
            { path: 'page-lock-docs', component: pages.PageLockDocsComponent },
            { path: 'page-delete-docs', component: pages.PageDeleteDocsComponent },            
            { path: 'page-access-right', component: pages.PageAccessRightComponent },
            { path: 'page-log-track', component: pages.PageLogTrackComponent },
            { path: 'page-logs', component: pages.PageLogsComponent },            
            { path: 'page-batch', component: pages.PageBatchComponent },
            { path: 'page-mail', component: pages.PageMailComponent },
            { path: 'fulltextsearch', component: pages.FulltextsearchComponent },
            { path: 'page-tree-search', component: pages.PageTreeSearchComponent },
            { path: 'page-tree-api', component: pages.PageTreeApiComponent },
            { path: 'page-request-list', component: pages.PageRequestListComponent,
                children : [...docksScreenRoutes,  { path: '', component: pages.NotFoundComponent, outlet: 'aux' }],
             },
            { path: 'page-request-last', component: pages.PageRequestListComponent },
            { path: 'page-request-api', component: pages.PageRequestApiComponent },
            { path: 'page-editors', component: pages.ListEditorsComponent },
            { path: 'page-basket-param', component: pages.PageBasketParamComponent },
            { path: 'preference', component: pages.PreferenceComponent },
            { path: 'page-param-docks-pos', component: pages.PageParamDocksPosComponent },            
            { path: 'page-export', component: pages.PageExportComponent },            
            { path: 'page-param', component: pages.PageParamComponent },
            ...routesResults,
            ...routesRequests,
            ...routesReqBsk,
            ...routesResBsk,
            ...routesUserBsk,
            ...routesTagBsk,
            ...routesScreenBsk,
            ...routesTagBase,
            ...routesEditors,
            ...routesCustRights,
            ...routesEditorRights,
            ...routesDelegateRights,
            ...routesDelegate,
            ...routesUser,
            ...routesBasket,
            ...routesGroup,
            ...routesCustMenuBase,
            ...customizedScreenRoutes,
            ...routesSupervBase,
            ...routesAdminDelegate,
            ...docksScreenRoutes,
            { path: '**', component: pages.NocontentComponent },
        ],
    },
];
